/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-11-23 10:44:04
 * @LastEditors: Please set LastEditors
 * @Description: 
 * @FilePath: \cloud_frontend\src\views\device\GroupingList\TableConfig.js
 * @
 */
import i18n from "../../../common/lang";
export const Columns=[
    {LabelName:i18n.t('lang.groupinglist.GroupName'),key:0,ColumnsKey:'group_name',seek:'group_name',placeholder:i18n.t('lang.groupinglist.search1'), sort: 'custom'},
    {LabelName:i18n.t('lang.groupinglist.GroupByTests'),key:1,ColumnsKey:'pgroupName',placeholder:i18n.t('lang.groupinglist.search2'),Fun:'GetGroupname', sort: 'custom'},
    {LabelName:i18n.t('lang.groupinglist.belonging'),key:2,ColumnsKey:'c_name',seek:'c_name',placeholder:i18n.t('lang.groupinglist.search3'),Fun:'GetCustomer', sort: 'custom'},
    {LabelName:i18n.t('lang.groupinglist.contact_to'),key:3,ColumnsKey:'username',seek:'username',placeholder:i18n.t('lang.groupinglist.search9'),Fun:'GetUsername', sort: 'custom'},
    {LabelName:i18n.t('lang.groupinglist.Creator'),key:4,ColumnsKey:'groupCreateName',seek:'groupCreateName',placeholder:i18n.t('lang.groupinglist.search4'), sort: 'custom'},
    {LabelName:i18n.t('lang.groupinglist.services'),key:5,ColumnsKey:'n2nInfoStatus',seek:'n2nInfoStatus',placeholder:i18n.t('lang.groupinglist.search5'),Fun:'GetGroupType', sort: 'custom'},
    {LabelName:i18n.t('lang.groupinglist.account_root'),key:6,ColumnsKey:'group_username',seek:'group_username',placeholder:i18n.t('lang.groupinglist.search6'),Fun:'GetRemotelyUsername', sort: 'custom'},
    {LabelName:i18n.t('lang.groupinglist.RemoteMailboxes'),key:7,ColumnsKey:'group_password',seek:'group_password',placeholder:i18n.t('lang.groupinglist.search7'),Fun:'GetRemotelyPassword', sort: 'custom'},
    {LabelName:i18n.t('lang.groupinglist.IPaux'),key:8,ColumnsKey:'edge_ip',seek:'edge_ip',placeholder:i18n.t('lang.groupinglist.search8'),Fun:'GetRemotelyIp', sort: 'custom'},
    {
        LabelName: i18n.t('lang.groupinglist.remoteBridge'), row: 80, align: 'center', key: 10, ColumnsKey: 'n2nInfoBridge', isCustom: true,
    },
    {LabelName:i18n.t('lang.groupinglist.Update'),key:9,row: 150,ColumnsKey:'group_updatetime',placeholder:i18n.t('lang.groupinglist.search9'), sort: 'custom'}
]

export const ColuumnsButton=[
    {key:0,type:'primary',icon:'icon-chaxun',Fun:'pushgrouping',Authority:56},
    {key:1,type:'primary',icon:'el-icon-edit',Fun:'modification',Authority:70},
    {key:2,type:'danger',icon:'el-icon-delete',Fun:'deletegrouping',Delete:true,Authority:69}
]
